import graphql__210122bbcfc45f094dba from "./__generated__/ContributionsDatavizListRouteQuery.graphql.js";import { graphql } from "react-relay";
import { useParams } from "react-router";

import AppQueryRenderer from "../AppQueryRenderer";
import ContributionsDatavizList from "../ParticipativeModule/Visualizations/ContributionsDataviz/ContributionsDatavizList";

const ContributionsDatavizListRoute = props => {
  const { participativeModuleSlug } = useParams();

  return (
    <AppQueryRenderer
      key={participativeModuleSlug}
      query={ContributionsDatavizListRouteQuery}
      variables={{ participativeModuleSlug }}
      component={ContributionsDatavizList}
      additionalProps={props}
    />
  );
};

const ContributionsDatavizListRouteQuery = graphql__210122bbcfc45f094dba;

export default ContributionsDatavizListRoute;
